"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../shared/UiStateController");
var routes_1 = require("../../shared/includes/routes");
var UILanguage_1 = require("../../UILanguage");
var P404 = /** @class */ (function (_super) {
    __extends(P404, _super);
    function P404(props) {
        return _super.call(this, props) || this;
    }
    P404.prototype.componentWillMount = function () {
        this.setState({
            lang: UILanguage_1.IUILanguageFactory.getLangInstance(this.props.state.getLang())
        });
    };
    P404.prototype.render = function () {
        return (React.createElement("div", { style: { float: "right", height: "100%", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" } },
            React.createElement("p", { style: { textAlign: "center", fontSize: 52, alignSelf: "center" } }, this.state.lang.pages.page_404.text_404)));
    };
    P404.getPageDescription = function (state) {
        return {
            icon: "",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_404 + "-id",
            itemTitle: "",
            route: routes_1.routes.page_404,
            docType: UiStateController_1.UIDocumentType.udt404Page
        };
    };
    return P404;
}(React.Component));
exports.default = P404;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/P404.tsx
// module id = 1719
// module chunks = 0